"use strict";
exports.__esModule = true;
var redux_form_1 = require("redux-form");
var clearFields = function (form, fields) { return function (dispatch) {
    for (var i = 0, n = fields.length; i < n; i++) {
        dispatch((0, redux_form_1.change)(form, fields[i], null));
    }
}; };
exports["default"] = clearFields;
